import { SegmentedControl } from 'cng-common/components/segmentedControl'
import { Translation, useSafetyTranslation } from 'cng-common/features/translations'
import { Input } from 'core-components/library/inputs'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'
import type { IPartnerDocumentSection } from '../../../../lib/documentsAndLinks'
import { CockpitSegmentedControlAccent } from '../../../components/cockpitSegmentedControlAccent'
import { countDocuments } from '../../lib/countDocuments'
import type { TDocumentType } from '../../types'

import styles from './DocumentsTreeToolbar.module.scss'

const DOCUMENT_TYPES: TDocumentType[] = ['elt', 'qbr']
const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.documentsAndLinks
interface IProps {
  sections: IPartnerDocumentSection[]
  documentType: TDocumentType
  grouping: 'partner' | 'creator'
  search: string
  onTypeChange: (type: TDocumentType) => void
  onGroupingChange: (grouping: 'partner' | 'creator') => void
  onSearchChange: (value: string) => void
}
export const DocumentsTreeToolbar = ({
  sections,
  documentType,
  grouping,
  search,
  onTypeChange,
  onGroupingChange,
  onSearchChange,
}: IProps) => {
  const t = useSafetyTranslation()
  return (
    <div className={styles.toolbar}>
      <CockpitSegmentedControlAccent className={styles.types}>
        <SegmentedControl
          useItemKeys
          selectedItem={documentType}
          onItemSelect={(next: string) => onTypeChange(next as TDocumentType)}
          size="small"
          variant="veneer"
        >
          {DOCUMENT_TYPES.map((type) => (
            <SegmentedControl.Item key={type} itemKey={type}>
              <Translation span text={type === 'elt' ? KEYS.sectionElt : KEYS.sectionQbr} />{' '}
              <span>{countDocuments(sections, type)}</span>
            </SegmentedControl.Item>
          ))}
        </SegmentedControl>
      </CockpitSegmentedControlAccent>
      <div className={styles.grouping}>
        <Translation span text={KEYS.grouping.label} />
        <CockpitSegmentedControlAccent>
          <SegmentedControl
            useItemKeys
            selectedItem={grouping}
            onItemSelect={(next: string) => onGroupingChange(next as 'partner' | 'creator')}
            size="small"
            variant="veneer"
          >
            {(['partner', 'creator'] as const).map((mode) => (
              <SegmentedControl.Item key={mode} itemKey={mode}>
                <Translation span text={KEYS.grouping[mode]} />
              </SegmentedControl.Item>
            ))}
          </SegmentedControl>
        </CockpitSegmentedControlAccent>
      </div>
      <Input
        value={search}
        onChange={onSearchChange}
        placeholder={t(KEYS.treeDocuments.search)}
        startContent={<i className="kbase kbase-search" />}
        classes={{ root: styles.search }}
      />
    </div>
  )
}
